import { createAsyncThunk } from '@reduxjs/toolkit'
import { type Observable } from 'rxjs'

const addObservable = createAsyncThunk<
	{ type: string; observable: Observable<any> }[],
	{ type: string; observable: Observable<any> }[]
>('core/addObservable', async (obj: { type: string; observable: Observable<any> }[]) => {
	return obj
})

export { addObservable }
